import loadable from "@loadable/component";
import { Route } from "react-router";
import CenteredSpinner from "../../components/centered-spinner/CenteredSpinner";
import { KNOWLEDGE_MANAGEMENT_ROUTES } from "../../config/routes";
import EmployeeCenter from "../../pages/knowledge-management/employee-center/EmployeeCenter";
import CrpClientsList from "../../pages/knowledge-management/crp-clients-list/CrpClientsList";
import CollaborationCenterLayout from "../../layouts/collaboration/CollaborationCenterLayout";

const options = {
  fallback: <CenteredSpinner />
}
const KMTHome = loadable(() => import(/* webpackChunkName: "KMTHome" */ '../../pages/knowledge-management/home/KMTHome'), options)
const Cip = loadable(() => import(/* webpackChunkName: "Cip" */  '../../pages/knowledge-management/cip/Cip'), options)
const AddClientPage = loadable(() => import( /* webpackChunkName: "AddClientPage" */ '../../pages/knowledge-management/cip/components/add-client/AddClientPage'), options)
const RFQ = loadable(() => import(/* webpackChunkName: "RFQ" */  '../../pages/knowledge-management/rfq/RFQ'), options)
const RFQDetail = loadable(() => import(  /* webpackChunkName: "RFQDetail" */  '../../pages/knowledge-management/rfq/rfq-detail/RFQDetail'), options)
const EndClientRfp = loadable(() => import(  /* webpackChunkName: "EndClientRfp" */  '../../pages/knowledge-management/end-client-rfp/EndClientRfp'), options)
const CollaborationCenter = loadable(() => import(  /* webpackChunkName: "CollaborationCenter" */  '../../pages/knowledge-management/collaboration-center/CollaborationCenter'), options)
const AddCollaborationDetails = loadable(() => import(  /* webpackChunkName: "AddCollaborationDetails" */  '../../pages/knowledge-management/collaboration-center/add-collaboration-details/AddCollaborationDetails'), options)
const AddNewCollaboration = loadable(() => import(  /* webpackChunkName: "AddNewCollaboration" */  '../../pages/knowledge-management/collaboration-center/add-new-collaboration/AddNewCollaboration'), options)
const ChangeClientPm = loadable(() => import(  /* webpackChunkName: "ChangeClientPm" */  '../../pages/knowledge-management/change-client-pm/ChangeClientPm'), options)


export default (
  <>
    <Route index element={<KMTHome />} />
    <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.EMPLOYEE_CENTER} element={<EmployeeCenter />} />
    <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.CHANGE_CLIENT_PM} element={<ChangeClientPm />} />
    <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.CRP_CLIENTS} element={<CrpClientsList />} />
    {/* <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.REQUEST_FOR_PROPOSAL_FOR_END_CLIENT} element={<EndClientRfp/>} /> */}
    <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.CIP}>
      <Route index element={<Cip />} />
      <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.ADD_CLIENT} element={<AddClientPage />} />
    </Route>
    <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.RFP}>
      <Route index element={<RFQ />} />
      <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.PROPOSAL_DETAIL} element={<RFQDetail />} />
    </Route>
    <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.COLLABORATION_CENTER} element={<CollaborationCenterLayout />}>
      <Route index element={<CollaborationCenter />} />
      <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.ADD_COLLABORATION_DETAIL} element={<AddCollaborationDetails />} />
      <Route path={KNOWLEDGE_MANAGEMENT_ROUTES.ADD_NEW_COLLABORATION} element={<AddNewCollaboration />} />
    </Route>
  </>
)